// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2906) return "static/chunks/2906-2471e7905d5d8e53.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5025":"5468bbfa7d312253","5778":"e8a653e7cb6a383b","8522":"3ce857caa0ff37ac"}[chunkId] + ".js";
};